import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  labelWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 2,
  },
  label: {
    fontSize: 14,
    color: custom.grey[2],
    fontWeight: 'normal',
    lineHeight: 1.43,
  },
  tooltip: {
    marginTop: 0,
  },
  value: {
    fontSize: 16,
    color: custom.grey[3],
    fontWeight: 'bold',
    lineHeight: 1.38,
  },
}));
